import { render, staticRenderFns } from "./PostTable.vue?vue&type=template&id=e6c37394&scoped=true&"
import script from "./PostTable.vue?vue&type=script&lang=js&"
export * from "./PostTable.vue?vue&type=script&lang=js&"
import style0 from "./PostTable.vue?vue&type=style&index=0&id=e6c37394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c37394",
  null
  
)

export default component.exports